// Състоянието на трите чипа-филтри на „Продажби по периоди".
//
// Отделен файл, не част от компонента: константите и помощниците се внасят и
// от страницата, а Fast Refresh иска файл с компонент да изнася само компоненти.

/** Стойността на „без клиент" в чипа „Клиенти" — не е клиент с id. */
export const WITHOUT_CLIENT = "none";

export interface ReportFilterState {
  userIds: string[];
  /** id-та на клиенти + евентуално `WITHOUT_CLIENT`. */
  clientIds: string[];
  itemIds: string[];
}

export const EMPTY_FILTERS: ReportFilterState = {
  userIds: [],
  clientIds: [],
  itemIds: [],
};

export const hasActiveFilters = (filters: ReportFilterState): boolean =>
  filters.userIds.length > 0 ||
  filters.clientIds.length > 0 ||
  filters.itemIds.length > 0;

